module.exports = __webpack_public_path__ + "static/media/congra-title-winner.ab5283cf.png";